module.exports = __webpack_public_path__ + "static/Obóz-2021-ulotka-1-eb1855c922643f948dd6ddfaef005dfe.pdf";